import { ReactComponent as ProfileSVG } from "./Profile.svg";
import { SvgIcon } from '@mui/material';

export default function IconProfile(props) {
  return <SvgIcon {...props} component={ProfileSVG} viewBox="0 0 25 25" />;
}